import styled from 'styled-components'
import { Colors } from 'theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px;
  width: 90%;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 24px;
`

export const BackArrowButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  position: absolute;
  left: 0;
`

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0 auto;
  text-align: center;
  color: ${Colors.darkGray};
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-left: 10px;
  margin-bottom: 20px;
`

export const Section = styled.div<{ heightPercent?: number }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: ${Colors.darkGray};
`

export const Text = styled.p`
  font-size: 14px;
  color: ${Colors.grayTextLight};
  line-height: 1.4;
  margin: 5px 0 0 0;
`

export const StrongUnderline = styled.span`
  text-decoration: underline;
`

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 90px;
  border-top: 1px solid ${Colors.grayLight};
  padding-top: 16px;
`

export const LinkItem = styled.a`
  font-size: 16px;
  color: ${Colors.purple};
  text-decoration: underline;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
`

export const Button = styled.button`
  margin: 24px auto 0;
  width: 230px;
  height: 52px;
  background-color: ${Colors.purple};
  color: ${Colors.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`

export const getDrawerStyles = () => {
  const mobileDevice = window.innerWidth < 600
  if (mobileDevice) {
    return { width: '100%' }
  }
  return { width: '400px' }
}
